// extracted by mini-css-extract-plugin
export default {"titlePage":"detailFeature_titlePage__IhAQG"};